import { createSelector } from 'reselect'
import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'
import { selectLoggedIn } from 'selectors/accountSelectors'

/**
 * Whether a logged-in customer is offered to reopen their Société account in place of joining: their
 * account failed to load, e.g. because it's closed. Join offers (`getCanJoinLoyalty`) never show to
 * them, since enrolment refuses an account in error.
 */
const getCanReopenLoyaltyAccount = createSelector(
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => selectLoggedIn(state),
  (state: App.State) => state.loyalty.account,
  (loyaltyEnabled, isLoggedIn, loyaltyAccount): boolean => {
    if (!loyaltyEnabled || !isLoggedIn) return false
    return !loyaltyAccount.fetching && !!loyaltyAccount.error
  },
)

export default getCanReopenLoyaltyAccount
